import * as React from 'react';
import { classes } from '../components/Button';
import { Link } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import GuideList from '../components/GuideList';
import Page from '../components/Page';
import Section from '../components/Section';
import { ProfileContext } from '../profile';
import CompanyGuideList from '../components/CompanyGuideList';
import { newGuide } from '../components/NewGuideCard';

export default (props: RouteComponentProps<any>) => {
  const { profile } = React.useContext(ProfileContext);

  return (
    <Page
      title="Brew Guides"
      subtitle="Share brew guides paired with your products"
    >
      <div className="flex justify-center ml-auto mr-auto">
        <Link
          to={{
            pathname: '/guides/edit/new',
            state: { guide: newGuide(profile) },
          }}
          className={`${classes} dib ml-auto mr-auto`}
        >
          Create new
        </Link>
      </div>
      {profile.company && (
        <Section title={`${profile.company.name}'s brew guides`}>
          <CompanyGuideList />
        </Section>
      )}
      <Section title="Your brew guides">
        <GuideList />
      </Section>
    </Page>
  );
};
